<div class="backpage-wrapper">
  <div class="credential-library-container">
    <div class="header">
      <img
        src="../../../../assets/Logos/zentra_logo-removebg-preview 1.png"
        alt="zentra green logo"
        width="50"
        height="50"
      />
      <h1>Zentra Subscriptions - Admin Portal</h1>
    </div>
    <br />
    <div class="zentra-table-section">
      <div class="tabs-header-wrapper">
        <mat-tab-group
          [(selectedIndex)]="selectedTabIndex"
          (selectedIndexChange)="onTabChange($event)"
        >
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">schedule</mat-icon>
              Subscriptions Pending Payment
            </ng-template>
            <div class="tab-content">
              <div class="tab-description">
                <mat-icon>info_outline</mat-icon>
                <p>
                  Subscriptions configured by admin and sent to purchasers
                  awaiting payment completion. *Subscription will be created in
                  Maxio*
                </p>
              </div>
              <mat-table
                #table
                [dataSource]="dataSource"
                matSort
                #pendingSort="matSort"
                class="fixed-table"
              >
                <ng-container matColumnDef="dateCreated">
                  <mat-header-cell
                    class="header-cell date-column-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Date Modified</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        placeholder="Search Date"
                        (keyup)="applyInputFilter($event, 'dateCreated')"
                        (dateChange)="applyDateFilter($event.value)"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="date-column">{{
                    element.createdDate
                      ? (element.createdDate | date: "MM/dd/yyyy")
                      : "No Date Provided"
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="subscriptionIdentifier">
                  <mat-header-cell
                    class="header-cell date-column-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Subscription Identifier</mat-label>
                      <input
                        matInput
                        placeholder="Search Identifier"
                        (keyup)="
                          applyInputFilter($event, 'subscriptionIdentifier')
                        "
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="date-column">{{
                    element.subscriptionIdentifier || "No Identifier Provided"
                  }}</mat-cell>
                </ng-container>

                <!-- Product Column with Input Filter -->
                <ng-container matColumnDef="productName">
                  <mat-header-cell
                    class="header-cell product-column-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Product Name</mat-label>
                      <input
                        matInput
                        placeholder="Search Product"
                        (keyup)="applyInputFilter($event, 'productName')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="product-column">{{
                    element.subscriptionData.product_name ||
                      "No Product Name Provided"
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="configuredComps">
                  <mat-header-cell
                    class="header-cell component-column"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Components</mat-label>
                      <input
                        matInput
                        placeholder="Search Components"
                        (keyup)="applyInputFilter($event, 'configuredComps')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="configured-comps-cell"
                  >
                    <ng-container
                      *ngIf="
                        element.subscriptionData.components &&
                        element.subscriptionData.components.length > 0
                      "
                    >
                      <div
                        *ngFor="
                          let component of element.subscriptionData.components
                        "
                        class="component-container"
                      >
                        <div class="component-name">
                          {{ component.name || "No Component Name Provided" }}
                        </div>
                        <div>Qty: {{ component.allocated_quantity }}</div>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !element.subscriptionData.components ||
                        element.subscriptionData.components.length === 0
                      "
                    >
                      No Components Available
                    </ng-container>
                  </mat-cell>
                </ng-container>

                <!-- Integrator Name Column with Input Filter -->
                <ng-container matColumnDef="integratorName">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Integrator Name</mat-label>
                      <input
                        matInput
                        placeholder="Search Integrator Name"
                        (keyup)="applyInputFilter($event, 'integratorName')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{
                    element.subscriptionData.metafields?.integratorName ||
                      "No Integrator Name Provided"
                  }}</mat-cell>
                </ng-container>

                <!-- Purchaser Column -->
                <ng-container matColumnDef="purchaserEmail">
                  <mat-header-cell
                    class="header-cell purchaser-email-header"
                    *matHeaderCellDef
                  >
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Purchaser Email</mat-label>
                      <input
                        matInput
                        placeholder="Search Purchaser Email"
                        (keyup)="applyInputFilter($event, 'purchaserEmail')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="purchaser-email-cell"
                    ><span class="email-text">{{
                      element.purchaserEmail || "No Purchaser Email Provided"
                    }}</span>
                  </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <mat-header-cell
                    class="header-cell actions-column-header"
                    *matHeaderCellDef
                  ></mat-header-cell>
                  <mat-cell *matCellDef="let element" class="actions-column">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="moreMenu"
                      color="accent"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #moreMenu="matMenu">
                      <button mat-menu-item (click)="editItem(element)">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="deleteItem(element)">
                        <mat-icon>delete</mat-icon>
                        <span>Delete</span>
                      </button>
                    </mat-menu></mat-cell
                  >
                </ng-container>
                <!-- Header Row Definitions -->
                <mat-header-row
                  *matHeaderRowDef="displayedColumns"
                ></mat-header-row>
                <!-- Data Row Definitions -->
                <mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></mat-row>
                <!-- No Data Row -->
                <tr class="mat-row" *matNoDataRow>
                  <td
                    class="mat-cell"
                    [attr.colspan]="displayedColumns.length"
                    style="text-align: center; padding: 24px"
                  >
                    No pending subscriptions found
                  </td>
                </tr>
              </mat-table>

              <!-- Paginator -->
              <mat-paginator
                #pendingPaginator
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">receipt_long</mat-icon>
              PO Subscriptions
            </ng-template>
            <div class="tab-content">
              <div class="tab-description">
                <mat-icon>info_outline</mat-icon>
                <p>
                  Active subscriptions created through internal purchase order
                  processing. *No Maxio involvement, purely for admin visibility
                  and management of PO subscriptions*
                </p>
              </div>
              <mat-table
                #poTable
                [dataSource]="poSubsDataSource"
                matSort
                #poSort="matSort"
                class="fixed-table"
              >
                <!-- Company Name Column -->
                <ng-container matColumnDef="companyName">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Company Name</mat-label>
                      <input
                        matInput
                        placeholder="Search Company Name"
                        (keyup)="applyPOInputFilter($event, 'companyName')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="company-name-cell"
                    >{{
                      element.companyName || "No Company Name Provided"
                    }}</mat-cell
                  >
                </ng-container>

                <!-- Customer Email Column -->
                <ng-container matColumnDef="customerEmail">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Customer Email</mat-label>
                      <input
                        matInput
                        placeholder="Search Customer Email"
                        (keyup)="applyPOInputFilter($event, 'customerEmail')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="customer-email-cell"
                    >{{
                      element.customerEmail || "No Customer Email Provided"
                    }}</mat-cell
                  >
                </ng-container>

                <!-- PO Number Column -->
                <ng-container matColumnDef="poNumber">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>PO Number</mat-label>
                      <input
                        matInput
                        placeholder="Search PO Number"
                        (keyup)="applyPOInputFilter($event, 'poNumber')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="po-number-cell">{{
                    element.poNumber || "No PO Number Provided"
                  }}</mat-cell>
                </ng-container>

                <!-- SKU Column -->
                <ng-container matColumnDef="sku">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>SKU</mat-label>
                      <input
                        matInput
                        placeholder="Search SKU"
                        (keyup)="applyPOInputFilter($event, 'sku')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="sku-cell">{{
                    element.sku || "No SKU Provided"
                  }}</mat-cell>
                </ng-container>

                <!-- Start Date Column -->
                <ng-container matColumnDef="subStartDate">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Start Date</mat-label>
                      <input
                        matInput
                        [matDatepicker]="poStartDatePicker"
                        placeholder="Search Start Date"
                        (dateChange)="applyPODateFilter($event.value)"
                        (input)="$any($event.target).value === '' && applyPODateFilter(null)"
                        #poDateInput
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="poStartDatePicker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #poStartDatePicker></mat-datepicker>
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="start-date-cell">{{
                    element.subStartDate
                      ? (element.subStartDate | date: "MM/dd/yyyy")
                      : "No Start Date Provided"
                  }}</mat-cell>
                </ng-container>

                <!-- Property Name Column -->
                <ng-container matColumnDef="propertyName">
                  <mat-header-cell class="header-cell" *matHeaderCellDef>
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Property Name</mat-label>
                      <input
                        matInput
                        placeholder="Search Property Name"
                        (keyup)="applyPOInputFilter($event, 'propertyName')"
                      />
                    </mat-form-field>
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let element"
                    class="property-name-cell"
                    >{{
                      element.propertyName || "No Property Name Provided"
                    }}</mat-cell
                  >
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <mat-header-cell
                    class="header-cell actions-column-header"
                    *matHeaderCellDef
                  ></mat-header-cell>
                  <mat-cell *matCellDef="let element" class="actions-column">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="poMenu"
                      color="accent"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #poMenu="matMenu">
                      <button mat-menu-item (click)="editPOItem(element)">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                      </button>
                    </mat-menu></mat-cell
                  >
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="poSubsDisplayedColumns"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: poSubsDisplayedColumns"
                ></mat-row>
                <!-- No Data Row -->
                <tr class="mat-row" *matNoDataRow>
                  <td
                    class="mat-cell"
                    [attr.colspan]="poSubsDisplayedColumns.length"
                    style="text-align: center; padding: 24px"
                  >
                    No PO subscriptions found
                  </td>
                </tr>
              </mat-table>

              <mat-paginator
                #poPaginator
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </mat-tab>
        </mat-tab-group>

        <div class="header-action-buttons">
          <button
            mat-flat-button
            color="secondary"
            (click)="openIntegratorInvite()"
          >
            <mat-icon>person_add</mat-icon>
            Invite User
          </button>
          <button
            mat-flat-button
            color="primary"
            routerLink="/zentra-subscriptions-config"
          >
            <mat-icon>add</mat-icon>
            Create Subscription
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
